import React from 'react'
import { useSelector } from '~/store/hooks'

import trads from '~/intl/trads.json'

import { Close } from '~/icons/Close'

const ButtonClose = ({ action, color, className }) => {
  const lang = useSelector((state) => state.lang)

  return (
    <button
      className={`button-close text-${color} ${className}`}
      onClick={action}
    >
      <span className={`button-close__icon button-close__icon--${color}`}>
        <Close className={`icon-${color}`} />
      </span>
      <span>{trads[lang]?.header?.burgerOpen}</span>
    </button>
  )
}

export default ButtonClose
